import { create } from "zustand";
import { PdfInterface } from "./interface/pdf-store.interface";
import { FilterPdfProps } from "src/entity/pdf/pdf.entity";

const currentYear = new Date().getFullYear();

export const pdfStore = create<PdfInterface>((set) => ({
  filter: null,
  setFilter: async (value: FilterPdfProps | null) => {
    set(() => ({
      filter: value,
    }));
  },
}));
